//libs
import React, { useCallback, useEffect, useState } from 'react';
import c from 'classnames';
import { NodeSelection } from 'prosemirror-state';
//types
import { EditorView } from 'prosemirror-view';

//components
import { Box, Stack, Typography } from '@lyearn/ui';

//consts
import { DividerTypes as DividerTypesEnum } from '../../../../nodes/HorizontalRule/types';
import { setNodeAttrs } from '../../../../utils';
//styles
import { setWidth } from './styles';

interface DividerTypesProps {
  view: EditorView;
}

const DividerTypesList = [
  { label: 'Light', id: DividerTypesEnum.Light, width: 58 },
  { label: 'Regular', id: DividerTypesEnum.Regular, width: 75 },
  { label: 'Bold', id: DividerTypesEnum.Bold, width: 53 },
];

const DividerTypes: React.FC<DividerTypesProps> = (props) => {
  const { view } = props;
  const [selectedType, setSelectedType] = useState<DividerTypesEnum | null>(null);
  let type: null | DividerTypesEnum = null;
  if (view) {
    type = (view.state.selection as NodeSelection).node?.attrs?.type;
  }

  useEffect(() => {
    if (type) {
      setSelectedType(type);
    }
  }, [type]);

  const onAction = useCallback(
    (dividerType: DividerTypesEnum) => {
      if (!view) {
        return;
      }
      const currentSelectionNode = (view.state.selection as NodeSelection).node;
      if (DividerTypesList.map((divider) => divider.id).includes(dividerType)) {
        setNodeAttrs(view, view.state.selection.$from.pos, {
          ...currentSelectionNode?.attrs,
          type: dividerType,
        });
      }
    },
    [view],
  );

  const onClick = useCallback(
    (event: any) => {
      const dividerType = event.currentTarget.getAttribute('data-divider-type') as DividerTypesEnum;
      onAction(dividerType);
    },
    [onAction],
  );

  return (
    <Stack alignItems="center" className="p-10 pe-6">
      {DividerTypesList.map((dividerType) => {
        return (
          <Box
            key={dividerType.id}
            className={c(
              'cursor-pointer rounded-4 p-4 me-4 hover:bg-interactive-white-hover',
              //seting fixed (max) width to prevent jitter while changing types
              setWidth(dividerType.width),
            )}
            data-divider-type={dividerType.id}
            role="button"
            onClick={onClick}>
            <Typography
              as="p"
              className="py-4 px-8"
              color={selectedType === dividerType.id ? 'text-text-primary' : 'text-text-secondary'}
              variant={selectedType === dividerType.id ? 'label-02' : 'body-short-02'}>
              {dividerType.label}
            </Typography>
          </Box>
        );
      })}
    </Stack>
  );
};

export default DividerTypes;
